import { onMounted, ref, watch } from 'vue';
import { useStore } from '@/store';

type FlowTimezoneConditionEntry = {
  values: string | string[];
};

type FlowConditions = Record<string, FlowTimezoneConditionEntry>;

type TimezoneListItem = {
  zone: string;
  name: string;
};

export const useFlowTimezoneCondition = (conditions: FlowConditions) => {
  const store = useStore();
  const timezone = ref<TimezoneListItem>({ name: 'UTC', zone: 'UTC' });

  watch(
    () => conditions,
    () => {
      if (!conditions.timezone) {
        conditions.timezone = {
          values: [],
        };
      }
    },
    { immediate: true },
  );

  watch(
    () => timezone.value?.zone,
    (value) => {
      if (value) {
        conditions.timezone = { values: value };
      }
    },
  );

  onMounted(() => {
    timezone.value =
      store.timezoneList.find((item) => item.zone === conditions.timezone.values)
      || store.timezoneList.find((item) => item.zone === 'UTC')
      || timezone.value;
  });

  return {
    timezoneList: store.timezoneList,
    timezone,
  };
};
